var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.phone)?_c('div',{staticClass:"button"},[_c('p',[_vm._v("如有疑问请联系当地分公司："),_c('span',[_vm._v(_vm._s(_vm.phone))])]),_vm._v(" "),_c('p',[_vm._v("（10:00-12:00，14:00-18:00）")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64153620","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/appointed-road-test/components/BottomLayout.vue
// module id = null
// module chunks = 